export const styles = {
    container: {
        display: ["block", "none"],
        w: "100%",
        mb: 2,
        position: "relative",
    },
    button: {
        display: "flex",
        justifyContent: "space-between",
        py: 6,
        px: 3,
        _focus: {
            boxShadow: "none",
        },
        _expanded: {
            py: 6,
            px: 3,
        },
        _hover: {
            bg: "white",
        },
    },
    panel: {
        pb: 6,
        px: 3,
    },
};
